module.exports = __webpack_public_path__ + "static/media/combined.2fb0d9fe.webm";